import {useObserver} from './useObserver'
import {isomorphicObserver} from 'quickstart/utils/isomorphic-observer'

/**
 * Use a callback ref with IntersectionObserver.
 */
export const useIntersectionObserver = (...args) =>
  useObserver(isomorphicObserver('IntersectionObserver'), ...args)
